module.exports = __webpack_public_path__ + "img/monitor.0805b3d8.svg";